<script lang="ts">
  import DiceTray from '../dice-tray/dice-tray.svelte';
  import { selectFaceData } from './modals';
  import Frame from '../components/frame.svelte';
  import Chrome from '../components/chrome.svelte';
  import type { Die } from '../models/die.type';

  let onConfirm: Function | null = null;
  /** Index of the chosen face on the die, not the face itself. */
  let face: number | null = null;
  let faces: Array<Die> = $state.raw([]);

  selectFaceData.subscribe((value) => {
    if (value && value.callback) {
      onConfirm = value.callback;

      faces = Array.from({ length: 6 }, (_, i) => {
        const die = value.die.clone();
        die.activeFace = i;
        die.id = 'x' + i;
        die.selected = false;
        return die;
      });
    } else {
      onConfirm = null;
    }
  });

  const confirm = () => {
    if (onConfirm) {
      onConfirm(face);
    }
    selectFaceData.set(null);
  };

  function chooseDie(selectedDie: Die) {
    /*if(selectedDie.used){
      return;
    }*/
    face = selectedDie.activeFace;

    // New dice rather than flipping `selected` on the old ones: a die changed in
    // place is the same object, and the tray would have no reason to redraw it.
    faces = faces.map((die: Die) => {
      const next = die.clone();
      next.selected = die === selectedDie;
      return next;
    });
  }
</script>

{#if $selectFaceData}
  <div class="modal-container">
    <div class="modal">
      <Frame>
        <div class="header">
          <h1>Select a Die</h1>
        </div>

        <div class="body">
          <DiceTray
            dice={faces}
            clickEvent={(die: Die) => {
              chooseDie(die);
            }}
            clazz="horizontal"
          />
        </div>

        <div class="functions">
          <Chrome chroming="gold" edge="circle" thickness="thin" click={confirm}>
            <div class="button">Confirm</div>
          </Chrome>
        </div>
      </Frame>
    </div>
  </div>
{/if}

<style lang="less">
</style>
